import { Component, OnInit } from '@angular/core';
// import { ContentSetup } from './model/contents.model';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'foliage';
 
  ngOnInit(): void {
  }
  

}
